import { createElement } from 'react';
import url from '../../http/url';
const Images = function Images({ imgList, style: styleOption = {}, uploadData, isHeight }) {
    const defaultValue = [];
    if (uploadData) {
        uploadData.forEach(item => {
            if (item.response.resultCode === 200) {
                defaultValue.push({
                    uid: (new Date()).getTime(),
                    name: item.name,
                    state: "done",
                    url: `${url.url}/image/${item.response.data}`,
                });
            }
        });
    }
    if (imgList) {
        imgList.forEach(item => {
            if (item.imgUrl) {
                defaultValue.push({
                    uid: (new Date()).getTime(),
                    name: item.imgName,
                    state: "done",
                    url: item.imgUrl,
                });
            }
        });
    }
    const imgWidth = `${Math.floor(100 / defaultValue.length)}%`;
    return (createElement("div", { style: { overflow: 'hidden', height: '200px', ...styleOption } }, defaultValue.map((item, index) => createElement("img", { src: item.url, alt: item.name, style: { width: imgWidth, height: isHeight ? 'auto' : '100%' }, key: index }))));
};
export default Images;
